import type { NewsFeedTypeItem, NewsFeedTypeItemFR } from './enums/NewsFeedTypeItem';
import { getNewsFeedTypeItemFromFR } from './enums/NewsFeedTypeItem';
import type { NewsItem } from '@app/models/api/NewsFeedItem';

export type NewsFeedCommonOperationModel = {
	id: number;
	name: string;
};

export type NewsFeedCommonOperationResponse = {
	id: number;
	nom: string;
};

export const translateNewsFeedCommonOperationResponse = (
	n: NewsFeedCommonOperationResponse
): NewsFeedCommonOperationModel => {
	return {
		id: n.id,
		name: n.nom
	};
};

export const translateNewsFeedCommonOperationResponseArray = (
	newsFeedCommonOperationResponses: NewsFeedCommonOperationResponse[]
): NewsFeedCommonOperationModel[] => {
	return newsFeedCommonOperationResponses?.map((e) => translateNewsFeedCommonOperationResponse(e));
};

export type NewsFeedCommonModel = {
	idObjet: number;
	type: NewsFeedTypeItem;
	date: string;
	title: string;
	text: string;
	targetName: string;
	seen: boolean;
	subscriptionsIds: number[];
	investedOperations?: NewsFeedCommonOperationModel[];
	relatedOperations?: NewsFeedCommonOperationModel[];
	logoUrl: string;
	isAssembleeWiseed?: boolean;
};

export const getNewsLatestOperation = (
	n: NewsItem | NewsFeedCommonModel
): NewsFeedCommonOperationModel | undefined => {
	let operations: NewsFeedCommonOperationModel[] = [];
	let idsArray: number[];
	let latestID: number;
	let latestOperation: NewsFeedCommonOperationModel | undefined = undefined;

	if (n.investedOperations?.length) {
		operations = n.investedOperations;
	} else if (n.relatedOperations?.length) {
		operations = n.relatedOperations;
	}

	if (operations.length) {
		idsArray = operations.map((operation) => operation.id);
		latestID = Math.max(...idsArray);
		latestOperation = operations.filter((o) => o.id === latestID)[0];
	}

	return latestOperation;
};

export const getNewsLatestOperationID = (n: NewsItem | NewsFeedCommonModel): number | undefined => {
	return getNewsLatestOperation(n)?.id;
};

export const getNewsLatestSubscriptionID = (subscriptionsID: number[]): number | undefined => {
	return subscriptionsID?.length > 0 ? Math.max(...subscriptionsID) : undefined;
};

export const getNewsLatestOperationName = (n: NewsFeedCommonModel): string => {
	return getNewsLatestOperation(n)?.name ?? n.targetName;
};

export type NewsFeedCommonResponse = {
	idObjet: number;
	type: NewsFeedTypeItemFR;
	date: string;
	title: string;
	text: string;
	targetName: string;
	seen: boolean;
	souscriptionsIds: number[];
	operationsInvesties?: NewsFeedCommonOperationModel[];
	operationsLiees?: NewsFeedCommonOperationModel[];
	logoUrl: string;
	isAssembleeWiseed?: boolean;
};

export const translateNewsFeedResponse = (o: NewsFeedCommonResponse): NewsFeedCommonModel => {
	return {
		idObjet: o.idObjet,
		type: o.type && getNewsFeedTypeItemFromFR(o.type),
		date: o.date,
		title: o.title,
		text: o.text,
		targetName: o.targetName,
		seen: o.seen,
		subscriptionsIds: o.souscriptionsIds,
		investedOperations:
			o.operationsInvesties && translateNewsFeedCommonOperationResponseArray(o.operationsInvesties),
		relatedOperations:
			o.operationsLiees && translateNewsFeedCommonOperationResponseArray(o.operationsLiees),
		logoUrl: o.logoUrl,
		isAssembleeWiseed: o.isAssembleeWiseed
	};
};
